const isBrowser = typeof window !== 'undefined';

function getLocation() {
  if (!isBrowser) return null;
  return window.location;
}

const location = getLocation();

export const hostName: string = location ? `${location.origin}/` : '';
export const currentUrl: string = location?.href ?? '';
export const hostUrl: string = location?.host ?? '';
export const pathName: string = location?.pathname ?? '';
export const origin: string = location?.origin ?? '';
export const queryStringFromUrl: string = location?.search ?? '';
export const searchQueryFromUrl: string = location ? queryString() : '';

export function getQueryParam(key: string): string | null {
  if (!isRenderingOnServer()) {
    return new URLSearchParams(window.location.search).get(key);
  }
  return new RegExp(`[?&]${key}=([^&]*)`).exec(queryStringFromUrl)?.[1] ?? null;
}

export function isRenderingOnServer(): boolean {
  return typeof window === 'undefined' || Boolean((window as any).ssr);
}

function queryString(): string {
  const params = window.location.search;
  if (!params) return '';

  const ALLOWED_PARAMS = new Set(['geolocation', 'f', 'sort', 'c']);
  const urlParams = new URLSearchParams(params);

  if (urlParams.has('g')) {
    urlParams.set('geolocation', urlParams.get('g')!);
    urlParams.delete('g');
  }

  Array.from(urlParams.keys())
    .filter((key) => !ALLOWED_PARAMS.has(key))
    .forEach((key) => urlParams.delete(key));

  return `?${urlParams.toString()}`;
}
